import Select from "react-select";
import makeAnimated from "react-select/animated";
import React, { useState, useEffect } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import swal from "sweetalert";
import { toast } from "react-toastify";

import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import bookclosurecss from "./../../css/bookclosure.module.css";
import Modal from "./../../elements/Modal";
import CustomDropdownIndicator from "./../../elements/CustomDropdownIndicator";
import InputGroup from "./../../elements/InputGroup";
import { ReqFieldLabel } from "./../../components/mis";
import { Button } from "./../../elements/Button";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as CalenderIcon } from "../../assets/icons/calender.svg";
import { customStyles } from "../../../Bookclosure/Components/AddTaskModal";
import { addCommentApiHandler } from "../../../Bookclosure/Services/ApiHandler";

const AddCommentModal = ({
  setAddCommentModal,
  taskId,
  assignOptions,
  setCommentsList,
  taskComment,
  setTaskComment
}) => {
  const animatedComponents = makeAnimated();
  const [comment, setComment] = useState(taskComment);

  const [assignee, setAssignee] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [tag, setTag] = useState(null);

  const postComment = () => {
    if (!taskId) {
      // toast.warning("Please Save The Task.");
      swal("Please Save The Task.",'warning');
      return;
    }
    const payload = {
      text: comment,
      assignee: assignee?.value,
      dueDate: dueDate,
    };
    console.log(payload);
    addCommentApiHandler(taskId, payload)
      .then((response) => {
        // console.log("response", response.dat a.comments);
        setCommentsList(response.data.comments.reverse());
        setAddCommentModal(false);
        setTaskComment('');
        // toast.success("Comment posted successfully.");
        swal("Success", "Comment posted successfully.", 'success')
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to add Comment",
          "error"
        );
      });
  };
  return (
    <Modal
      title="Create Comment"
      width="40%"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <CloseIcon
          onClick={() => {
            setAddCommentModal(false);
          }}
          className="clickable"
        />
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setAddCommentModal(false);
            }}
            label="Cancel"
          />
          <Button
            btnColor={buttoncss.primary}
            label="Post Comment"
            onClick={postComment}
          />
        </>
      }
    >
      <div style={{ padding: "10px 30px" }}>
        <InputGroup
          class_="mb-0"
          label="Comment"
          req={true}
          inputs={[
            <>
              <textarea
                rows={4}
                placeholder="Enter Comment"
                name="comment"
                value={comment}
                onChange={(e) => {
                  setComment(e.target.value);
                }}
              />
            </>,
          ]}
        />

        <InputGroup
          label="Add Assignee"
          req={true}
          inputs={[
            <>
              <Select
                placeholder="Select Assignee"
                name="assigneeId"
                value={assignee}
                onChange={(e) => {
                  setAssignee(e);
                }}
                options={assignOptions}
                className="w-100 mt-0"
                classNamePrefix="select"
                components={{
                  ...animatedComponents,
                  IndicatorSeparator: () => null,
                  DropdownIndicator: CustomDropdownIndicator,
                }}
                styles={customStyles}
              />
            </>,
          ]}
        />

        {/* <span className="input-label">
          <ReqFieldLabel />
          &nbsp;Add Assignee
        </span>
        <Select
          placeholder="Select Assignee"
          name="assigneeId"
          value={assignee}
          onChange={(e) => {
            setAssignee(e);
          }}
          options={assignOptions}
          className="w-100 mt-0 custom-bg-gray-300"
          classNamePrefix="select"
          components={animatedComponents}
          styles={customStyles}
        /> */}

        <InputGroup
          label="Due Date"
          inputs={[
            <>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                  <MobileDatePicker
                    className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                    value={dueDate ? dayjs(dueDate) : null}
                    onChange={(value) => {
                      if (value && dayjs(value).isValid()) {
                        const formattedDate = dayjs(value).format("DD-MM-YYYY");
                        setDueDate(formattedDate);
                      } else {
                        setDueDate("");
                      }
                    }}
                    format="DD-MMM-YYYY"
                    slotProps={{
                      textField: {
                        InputProps: {
                          disableUnderline: true,
                        },
                        inputProps: {
                          placeholder: "DD-MM-YYYY",
                        },
                        sx: {
                          "& fieldset": {
                            border: "none",
                          },
                        },
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <span className="icon">
                <CalenderIcon className="vaMiddle" width={20} height={20} />
              </span>
            </>,
          ]}
        />

        <InputGroup
        class_="mb-2"
          label="Add Tags"
          inputs={[
            <>
              <input
                name="tag"
                value={tag}
                onChange={(e) => {
                  setTag(e.target.value);
                }}
              />
            </>,
          ]}
        />
      </div>
    </Modal>
  );
};

export default AddCommentModal;
